module.exports = __webpack_public_path__ + "static/media/patrimoine.19e897f9.jpg";